import { Skeleton } from "../../../../shared/ui/Working";

/**
 * A SPANISH READER'S FIRST PAINT WHILE THE CATALOGUE LOADS (rc.12 (b), the Web
 * Director's option D). The Spanish catalogue is its own chunk; until it is
 * here, the page shows this instead of a blank screen, and never English.
 *
 * TEXT-FREE BY CONSTRUCTION: the page frame, the wordmark as a decorative
 * image (alt=""), and shimmer blocks. No strings at all: no footer, no language
 * switch, no visually hidden labels, no accessible name; the region is
 * `aria-busy`. Not a `<main>`: that landmark belongs to PageShell, and there
 * is nothing here to navigate to.
 * The real tree is mounted meanwhile but not displayed (index.css), so its data
 * reads run in parallel with the catalogue. The provider removes this once the
 * catalogue lands, or on a failure (English; the release notice only if a
 * newer release is live).
 *
 * The blocks are `contentful` Skeletons: drawn as inline SVG, they make this
 * the first contentful paint with no network. Measured on Slow 4G: the
 * wordmark image alone made the first contentful paint wait about 0.45 s for
 * its download.
 *
 * Only a Spanish reader's first load renders it; an English visit never does.
 */
export function BootSkeleton() {
  // Set before the first render (initializeAppearance, main.tsx).
  const dark = document.documentElement.dataset.theme === "dark";
  return (
    <div className="b3-boot" data-testid="boot-skeleton">
      <header className="v3-header b3-boot-head">
        <img src={dark ? "/wordmark-dark.png" : "/wordmark-light.png"} alt="" width={400} height={156} />
      </header>
      <div className="b3-boot-main" aria-busy="true">
        <div className="b3-boot-blocks" aria-hidden="true">
          <Skeleton contentful w="45%" h={14} r={4} />
          <Skeleton contentful w="70%" h={34} r={6} />
          <Skeleton contentful h={84} r={12} />
          <Skeleton contentful h={84} r={12} />
          <Skeleton contentful h={84} r={12} />
        </div>
      </div>
    </div>
  );
}
